/* src/components/tags/tags.component.scss */
.theBackground {
  height: 100%;
  width: 100%;
  background: transparent;
  position: absolute;
}
.cardContainer {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.centerText {
  text-align: center;
  padding-bottom: 0.2rem;
}
.acceptButton {
  margin-top: 13px;
  margin-right: 0px;
  margin-bottom: 0px;
}
/*# sourceMappingURL=tags.component.css.map */
